import { Outlet } from 'react-router-dom';

import s from './SubscriptionSettings.module.scss';

/**
 * The section shell. Both views under it — the vessel list and one vessel's detail —
 * are routes of their own; this only supplies the centred page column they share.
 */
export default function SubscriptionSettings() {
  return (
    <div className={s.shell}>
      <Outlet />
    </div>
  );
}
